(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/objects/scBlock/types/html/desktop', '<section class="html" role="region" aria-label="content">\n' + '  <div class="html_content" data-sc-compile="block.content"></div>\n' + '</section>\n' + '');
}]);
})();